import { h } from 'preact';
import React, { Component } from 'react';

export default class Switch extends Component {
  state = {
    isPurModelChecked: false,
    toggleDisplay: true,
  };

  toggle = (shouldCheck) => {
    const { child, value, vendors, consentType } = this.props;
    const isChecked = shouldCheck !== undefined ? shouldCheck : !this.props.checked;
    if (child === 'purposes' || child === 'features') {
      this.props.toggle(value._id, child, isChecked, vendors, this.props.legInt);
      this.setState({ checked: isChecked })
    } else if (child === 'vendors') {
      this.props.toggle(value.vendorId, isChecked, consentType);
      this.setState({ checked: isChecked })
    } else if (child === 'stacks') {
      this.props.toggle(value._id, isChecked);
      this.setState({ checked: isChecked })
    }
  }

  componentDidMount = () => {
    if(this.props.usePurModel){
      this.toggle(true);
    };
  };

  componentDidUpdate = (prevProps, prevState) => {
    if(this.props.usePurModel !== prevProps.usePurModel){
      this.setState({isPurModelChecked: this.props.usePurModel, toggleDisplay: !this.state.toggleDisplay}, () => {
        if (!this.props.selectedLi) {
          this.toggle(this.state.isPurModelChecked);
        }; 
      });
    } ;
  };
  
  render() {
    const {
      type,
      color,
      offColor,
      text,
      offText,
      colorActive,
      offActiveColor,
      checked,
      value: { name: ariaLabel },
      locked,
      tabbable
    } = this.props;

    const isToggleOn = !this.props.usePurModel || this.state.toggleDisplay && !this.props.usePurModel ? 'block' : 'none';
    const neutral = (
      <label
        tabIndex={tabbable === false ? -1 : 0}
        className={locked ? "pm-toggle locked" : "pm-toggle"}
        role="switch"
        aria-checked={checked ? 'true' : 'false'}
        aria-label={ariaLabel}
        tabindex="0"
        onKeyDown={(e) => e.keyCode === 13 && this.toggle(!checked ? true : false)}
        style={{ display: isToggleOn}}
      >
        <span
          className="off"
          style={{
            backgroundColor: !checked ? offColor : 'transparent',
            color: !checked ? offActiveColor : '#000000',
            borderColor: !checked ? offColor : '#dddddd',
          }}
          onClick={() => this.toggle(false)}
        >
          {offText}
        </span>
        <span
          className="on"
          style={{
            backgroundColor: checked ? color : 'transparent',
            color: checked ? colorActive : '#000000',
            borderColor: checked ? color : '#dddddd',
          }}
          onClick={() => this.toggle(true)}
        >
          {text}
        </span>
      </label>
    );

    const basicClassName = checked ? 'pm-switch checked' : 'pm-switch';

    const basic = (
      <label
        tabIndex={tabbable === false ? -1 : 0}
        className={locked ? basicClassName + ' locked' : basicClassName}
        role="switch"
        aria-checked={checked ? 'true' : 'false'}
        aria-label={ariaLabel}
        onKeyDown={(e) => {
          e.stopPropagation()
          e.keyCode === 13 && this.toggle()
        }}
        style={{ display: isToggleOn}}
      >
        <span className="slider round" style={{ backgroundColor: checked ? color : offColor }} onClick={() => this.toggle()}></span>
      </label>
    );

    return type === 'neutral' ? neutral : basic;
  }
}
